import CanvasController from './canvas-controller.js';
import { palette } from '../color.js';
import { generateLinearChirp, getInstantaneousFrequency } from '../chirp-things.js';

export default class ChirpWaveController extends CanvasController {

    constructor(id, width, height) {
        super(id, width, height);
        this.animAmt = 0;
        this.f0 = 0.02;
        this.f1 = 0.15;
        this.numSamples = 256;
        this.wavePoints = generateLinearChirp(this.f0, this.f1, this.numSamples);
        this.showFrequencyColor = true;
    }

    setChirpParams(f0, f1) {
        this.f0 = f0;
        this.f1 = f1;
        this.wavePoints = generateLinearChirp(this.f0, this.f1, this.numSamples);
    }

    update(dt, mousePosition) {
        const period = 4;
        this.animAmt += dt / period;
        this.animAmt %= 1;
    }

    render() {
        this.clear();
        this.context.save();
        this.context.translate(this.width / 2, this.height / 2);
        this.context.scale(this.canvas.width / this.width, this.canvas.height / this.height);
        this.renderWave();
        this.context.restore();
    }

    renderWave() {
        if (this.wavePoints.length === 0) return;

        const waveHeight = 0.35 * this.height;
        const waveWidth = 0.9 * this.width;
        const startX = -waveWidth / 2;

        this.context.lineWidth = 2;

        for (let i = 0; i < this.wavePoints.length - 1; i++) {
            const t1 = i / this.wavePoints.length;
            const t2 = (i + 1) / this.wavePoints.length;
            
            const x1 = startX + t1 * waveWidth;
            const x2 = startX + t2 * waveWidth;
            
            const offset = this.animAmt;
            const idx1 = (i + Math.floor(offset * this.numSamples)) % this.numSamples;
            const idx2 = (i + 1 + Math.floor(offset * this.numSamples)) % this.numSamples;
            
            const y1 = -this.wavePoints[idx1] * waveHeight;
            const y2 = -this.wavePoints[idx2] * waveHeight;

            if (this.showFrequencyColor) {
                const freq = getInstantaneousFrequency(t1, this.f0, this.f1);
                const normalizedFreq = (freq - this.f0) / (this.f1 - this.f0);
                this.context.strokeStyle = this.frequencyToColor(normalizedFreq);
            } else {
                this.context.strokeStyle = palette.blue;
            }

            this.context.beginPath();
            this.context.moveTo(x1, y1);
            this.context.lineTo(x2, y2);
            this.context.stroke();
        }
    }

    frequencyToColor(normalizedFreq) {
        const hue = 240 - normalizedFreq * 180;
        return `hsl(${hue}, 80%, 55%)`;
    }
}
